import { ensureArray } from 'lib/util/array';
import { env } from 'lib/env';

/**
 * Normalizes a redirect url to protect against XSS or blind redirect attacks
 * @param theUrl The url to normalize
 * @param defaultValue The url to return if the input url is invalid
 */
export const normalizeRedirectUrl = (
  theUrl: string | string[] | undefined,
  defaultValue: string | undefined = undefined
): string => {
  // Normalize input
  const inputUrl = ensureArray(theUrl || '/')[0].trim();
  const checkUrl = inputUrl.toLocaleLowerCase();
  // Is it either site-relative?
  if (checkUrl.startsWith('/')) return inputUrl;
  // or absolute scoped to our site ?
  const normalizedPublicUrl = `${env.PUBLIC_URL}/`;
  if (checkUrl.startsWith(normalizedPublicUrl)) return inputUrl;
  // If we made it here we are not valid
  return defaultValue || '/';
};

export const getPublicHostName = () => new URL(`${process.env.PUBLIC_URL as string}`).host;
export const getAbsolutePath = (url: string | URL): string => {
  if (!url) {
    return url;
  }
  const isString = typeof url === 'string';
  const asString = isString ? url : url.toString();
  const asUrl = new URL(asString, process.env.PUBLIC_URL);
  return asUrl.toString();
};

export const getWithoutCase = (
  params: URLSearchParams,
  paramName: string
): string | undefined | null => {
  const checkFor = paramName?.toLocaleLowerCase() ?? '';
  const keyName = Array.from(params.keys()).find((key) => key.toLowerCase() === checkFor);
  return keyName ? params.get(keyName) : undefined;
};

export type Falsy = false | 0 | '' | 'false' | null | undefined;

// this is a type predicate - if x is `truthy`, then it's T
export const isTruthy = <T>(x: T | Falsy): x is T => !!x && x !== 'false';
